var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBbd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_14925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2165 1.45805C15.6389 0.695209 13.869 0.267334 11.9991 0.267334C10.1293 0.267334 8.35939 0.695209 6.78177 1.45805L5.73828 12.2673L6.78177 23.0766C8.35939 23.8395 10.1293 24.2673 11.9991 24.2673C13.869 24.2673 15.6389 23.8395 17.2165 23.0766L18.26 12.2673L17.2165 1.45805Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78262 1.45862C2.76872 3.39952 0 7.50995 0 12.2675C0 17.025 2.76872 21.1354 6.78262 23.0763V1.45862Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2188 1.45862V23.0763C21.2327 21.1354 24.0014 17.025 24.0014 12.2675C24.0014 7.50999 21.2327 3.39952 17.2188 1.45862Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6528 7.56863L16.3528 7.9186L15.6528 7.56863L14.9527 7.21866C14.9105 7.30308 13.9965 9.16276 13.8472 12.0034H12.7832V7.56863L12.0006 6.52515L11.218 7.56863V12.0034H10.154C10.0046 9.16276 9.09064 7.30308 9.04841 7.21866L7.64844 7.91865C7.65809 7.93787 8.60933 9.87404 8.60933 12.7861V13.5687H11.218V18.0035H12.7832V13.5687H15.3919V12.786C15.3919 11.2805 15.6524 10.039 15.871 9.26269C16.1092 8.41613 16.3512 7.92174 16.3536 7.91682L15.6528 7.56863Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_14925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBbd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BBD.221764762c8bcb4db5acda53449784e4.svg";